import { render, staticRenderFns } from "./AmericanStories.vue?vue&type=template&id=23ec631b&"
import script from "./AmericanStories.vue?vue&type=script&lang=js&"
export * from "./AmericanStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports